import Player from './player';

export default class PlayerTiers extends Player {
    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        return {
            ...expandedPlayer,
            salary: 0,
            isExcludedBySalary(mode) {
                return false;
            },
            isFitForLineup(substitutablePlayer) {
                return substitutablePlayer.rosterPositionName === this.rosterPositionName;
            },
        };
    }
}
